<template>
  <div class="relative pt-4">
    <!-- <PopupWhoWeAre
      :isActive="isDetailsActive"
      :selectedWhoWeAre="selectedWhoWeAre"
      @close="toggleDetails"
    /> -->
    <div class="absolute bg-design6 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd6.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design7">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:py-0 md:py-0 w-full mx-auto" id="productToDisplay">
      <p class="title md:font-normal lg:font-normal font-bold sm-fsize20">
        All Products
      </p>
      <p class="fsize20 sm-fsize14">
        Each time you buy from the shop, you contribute to the education and
        livelihood of family caregivers from marginalized and underprivileged
        sections of society. Subscribe now to get special offers.
      </p>
      <div class="bg-white">
        <div class="mb-8">
          <h2 class="fsize25 font-semibold pt-8">
            <div class="py-2">
              <b-input-group class="mt-12">
                <b-form-input
                  class="border-none shadow-lg"
                  type="text"
                  min="0.00"
                  v-model="search"
                  placeholder="Enter Search...."
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    variant="white"
                    class="flex items-center shadow-lg"
                    aria-label="search"
                  >
                    <feather-icon
                      class="cursor-pointer mr-2"
                      icon="SearchIcon"
                      svgClasses="w-4 h-4"
                    ></feather-icon>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <div class="flex flex-row-reverse gap-15 align-center">
              <div>
                <b-button
                  class="bg-primary mx-2 my-1 text-white h-10 px-5 m-2 rounded-lg"
                  @click="showAll"
                  :disabled="brand === '' && search.trim() === ''"
                >
                  Clear all Filter
                </b-button>
              </div>
              <div class="w-52 mx-2 my-1 h-10 px-5 m-2">
                <multiselect
                  name="brand"
                  v-model="brand"
                  :options="brandFilter"
                  :multiple="false"
                  :close-on-select="true"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Brand"
                  track-by="name"
                  label="name"
                  :preselect-first="false"
                  @input="getAllProduct()"
                >
                </multiselect>
              </div>
            </div>
            <div>
              <div class="mt-12">
                <!-- {{ brands.name }} -->
                <!-- :key="brands._id" -->
                <div
                  class="grid lg:grid-cols-3 mt-2 md:grid-cols-2 grid-cols-1 lg:gap-4 md:gap-8 gap-4"
                >
                  <div
                    class="w-full px-4 rounded-xl"
                    v-if="products.result.length === 0"
                  >
                    <NoData title="No Product Found" />
                  </div>
                  <div
                    :class="{
                      custopacity: item.isURL == false && item.sku < 1,
                    }"
                    class="flip-card relative rounded-xl lg:mb-4 md:mb-12 mb-4 cursor-pointer shadow-lg bg-white mt-2"
                    @click="toggleDetails(true, item)"
                    v-for="item in products.result"
                    :key="item._id"
                  >
                    <!-- v-if="item.brandData[0].name == brands.name" -->
                    <div>
                      <div class="flip-card-inner">
                        <div class="flip-card-front">
                          <div class="w-full">
                            <img
                              v-if="item.productImage"
                              :src="`${$imageURL}/${item.productImage}`"
                              :alt="item.name"
                              class="h-280px sm-h-210 rounded-t-lg w-full object-contain"
                            />
                            <img
                              v-else
                              :src="$noIMG"
                              :alt="item.name"
                              class="frameht"
                            />
                          </div>
                          <div
                            class="w-full lg:px-4 md:px-4 px-2 py-3 text-center"
                          >
                            <p
                              class="lg:text-lg md:text-xl sm-fsize16 text-black line-clamp2 font-semibold pb-1 cursor-pointer"
                            >
                              {{ item.name }}
                            </p>
                            <span
                              class="fsize18px font-semibold sm-fsize14 lh32px sm-lineh21 cursor-pointer"
                            >
                              &#8377;{{ item.price }}
                            </span>
                            <div v-if="item.isURL == false">
                              <span
                                class="fsize16 sm-fsize10 font-normal lh32px sm-lineh21 cursor-pointer"
                                v-if="Object.keys(user).length !== 0"
                              >
                                <template
                                  v-if="
                                    parseInt(
                                      item.membershipDisc[membershipName]
                                    )
                                  "
                                >
                                  Get an additional discount of
                                  {{ item.membershipDisc[membershipName] }}% on
                                  your {{ membershipName }} plan
                                </template>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          class="flip-card-back flex text-center justify-center"
                        >
                          <div class="text-left px-3 pt-2">
                            <h2
                              class="lg:text-lg lineclamp-2 md:text-lg sm-fsize14 text-black font-semibold cursor-pointer"
                            >
                              {{ item.name }}
                            </h2>
                            <span class="underline fsize16"
                              >Seller: {{ item.brandData[0].name }}</span
                            >

                            <div>
                              <p class="ellipsis-12 fsize15 pt-1">
                                {{ item.description }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="item.isURL == false">
                        <div v-if="item.sku >= 1">
                          <a>
                            <div class="w-full absolute bottom-0 p-3">
                              <base-button
                                @click="addToCart(item._id)"
                                type="primary"
                                class="lg:py-2 md:py-2 py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                                >Add to Cart
                              </base-button>
                            </div>
                          </a>
                        </div>
                        <div v-else>
                          <a>
                            <div class="w-full absolute bottom-0 p-3">
                              <base-button
                                class="lg:py-2 custoutstock md:py-2 py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                                >Out of Stock
                              </base-button>
                            </div>
                          </a>
                        </div>
                      </div>
                      <div v-else>
                        <a :href="item.url" target="_blank">
                          <div class="w-full absolute bottom-0 p-3">
                            <base-button
                              type="primary"
                              class="lg:py-2 md:py-2 py-1 px-8 fsize16 sm-fsize14 border-2 whitespacenowrap mx-auto w-full"
                              >Buy Now
                            </base-button>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Category 1 -->
            </div>
          </h2>
          <b-card-footer class="py-4 d-flex justify-content-end">
            <b-pagination
              v-model="currentPage"
              @change="handleChangePage"
              :total-rows="totalRows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>
          </b-card-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import PopupWhoWeAre from "./PopupWhoWeAre.vue";
import { mapState } from "vuex";
import NoData from "./NoData.vue";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      selectedWhoWeAre: {},
      isDetailsActive: false,
      totalRows: 0,
      perPage: 12,
      currentPage: 1,
      tableData: [],
      brand: "",
      brandFilter: [],
      membershipName: "",
      search: "",
      brandId: "",
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.getAllProduct();
        this.currentPage = 1;
      }, 500),
    },
  },
  computed: {
    ...mapState("affiliate", {
      products: "products",
      brandData: "brandData",
      cartData: "cartData",
    }),
    ...mapState("auth", { user: "user", getUserByUserId: "getUserByUserId" }),
  },
  methods: {
    handleChangePage(page) {
      console.log(page);
      this.currentPage = page;
      this.getAllProduct();
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedWhoWeAre = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    async addToCart(id) {
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
        this.$swal
          .fire({
            title: "Login",
            text: "Please Login to continue viewing the blog",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showConfirmButton: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push({ name: "signin" });
            }
          });
        return;
      }
      // console.log(id);
      try {
        // await this.$store.dispatch("affiliate/getCart");
        // let flag = false;
        // console.log(this.cartData.data.result);
        // if (Object(this.cartData.data.result[0]).hasOwnProperty("productId")) {
        // this.cartData.data.result[0].productId.forEach((e) => {
        //   if (e._id == id) {
        //     flag = true;
        //   }
        // });
        // }
        // if (flag) {
        //   this.$swal.fire({
        //     // title: "Session Expired",
        //     text: "Product already added to cart!",
        //     icon: "info",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   });
        //   return;
        // }
        let data = await this.$store.dispatch("affiliate/addItem", {
          productId: id,
        });
        if (data.code == 200) {
          this.$notify({
            title: "Added",
            message: "Product added to cart!!",
            type: "success",
            duration: "1500",
            // icon: "success",
            // confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            // confirmButtonText: "Okay",
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.data.message.includes("Product not available")) {
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000,
          });
        }
      }
    },
    handleChangePage(page) {
      // console.log(page);
      this.currentPage = page;
      this.getAllProduct();
      let el = document.getElementById("productToDisplay");
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    async getAllProduct() {
      let brandId = "";
      if (this.brand !== "") {
        this.brandId = this.brand._id;
      }
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage * this.perPage,
        brandId: this.brandId,
        isAdminRequest: "false",
        search: this.search,
      };

      let loader;
      try {
        // console.log(payload);
        loader = this.$loading();
        const allProduct = await this.$store.dispatch(
          "affiliate/getAllProduct",
          payload
        );
        if (
          this.getUserByUserId.hasOwnProperty("currentMembership") &&
          this.getUserByUserId.currentMembership != null
        ) {
          this.membershipName = this.getUserByUserId.currentMembership.name;
        }
        // console.log(this.user);
        loader.close();

        this.totalRows = this.products.totalCount;
        // let data = this.products.result.map((d) => d);
        // this.lastData = data.pop();
        // console.log(this.lastData);
        this.tableData = this.products.result;
        // console.log(this.products);
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    async showAll() {
      try {
        this.brand = "";
        this.search = "";
        this.brandId = "";
        this.getAllProduct();
      } catch (error) {}
    },
  },
  async mounted() {
    if (window.location.pathname) {
      // console.log(window.location.pathname);
    }
    await this.$store.dispatch("affiliate/getBrand");
    this.brandData.forEach((ele) => {
      this.brandFilter.push(ele);
    });
    await this.getAllProduct();
  },
};
</script>
<style>
.offerImg {
  width: 375px;
  height: 330px;
  margin: auto;
  object-fit: cover;
}

.line-clamp2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.flip-card {
  background-color: transparent;
  width: 100%;
  height: 450px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  color: black;
}

.flip-card-back {
  background-color: #eee2ff;
  color: black;
  transform: rotateY(180deg);
}
.modal-header .close {
  position: absolute;
  right: 12px;
  top: 12px;
}
.w30rem {
  width: 30rem;
}
@media (max-width: 640px) {
  .flip-card {
    height: 360px !important;
  }
}
</style>
